require('./accountChequebookMovementsTable.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ actions
const accountChequeBookActions = require('actions/accountChequebook');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountChequebookMovementsTableRow = require('./accountChequebookMovementsTableRow/accountChequebookMovementsTableRow');
const { Button } = require('commonsComponents/button');
const { EmptyState } = require('commonsComponents/emptyState');
// @ constants
const { CHEQUEBOOK_FILTER_PAYED_RETURNED_COMPOSED } = require('constants/index');

class AccountChequebookMovementsTable extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    buildNextPageButton() {
        const { immChequebook } = this.props;
        let buttonContent;

        if (immChequebook.get('nextPage')) {
            buttonContent = (
                <div className="account-chequebook-movements-table__more-movements">
                    <Button
                        extraClass="button--link account-chequebook-movements-table__more-button"
                        onClick={this.handleNextPage}
                    >
                        <FormattedText
                            value="accountCheques-moreMovements"
                            format={__CONTACT_CENTER__ ? "uppercase" : undefined}
                        />
                    </Button>
                </div>
            );
        }

        return buttonContent;
    }

    buildTableBody() {
        const { immChequebook } = this.props;

        return immChequebook.get('byOrder').map((id, index) => {
            return (
                <AccountChequebookMovementsTableRow
                    key={index}
                    originalIndex={index}
                    immCheque={immChequebook.get('byId').get(id)}
                />
            );
        });
    }

    handleNextPage() {
        const { accountId, chequebookId, requestNextAccountChequebookPage } = this.props;
        requestNextAccountChequebookPage(accountId, chequebookId);
    }

    render() {
        const { immChequebook, chequebookFilter } = this.props;
        let content;

        if (!immChequebook.get('loading') && !immChequebook.get('error')) {
            if (immChequebook.get('byOrder').size > 0) {
                const tableBody = this.buildTableBody();
                const nextPageButton = this.buildNextPageButton();

                content = (
                    <div className="account-chequebook-movements-table">
                        <OKTable id="account-chequebook-movements">
                            <thead>
                                <OKTableRow asHeader={true}>
                                    <OKTableCell asHeader={true}>
                                        <FormattedText value="accountCheques-chequebookId" format="firstUppercase" />
                                    </OKTableCell>
                                    <OKTableCell asHeader={true}>
                                        <FormattedText value="accountCheques-chequebookStatus" format="firstUppercase" />
                                    </OKTableCell>
                                    <OKTableCell asHeader={true}>
                                        <FormattedText value="accountCheques-situationDate" format="firstUppercase" />
                                    </OKTableCell>
                                    <OKTableCell className="account-chequebook-movements-table__last-cell" asHeader={true}>
                                        <FormattedText value="accountCheques-chequebookBalance" format="firstUppercase" />
                                    </OKTableCell>
                                </OKTableRow>
                            </thead>
                            <tbody>
                                {tableBody}
                            </tbody>
                        </OKTable>
                        {nextPageButton}
                    </div>
                );
            } else {
                const noResultsText = (chequebookFilter !== CHEQUEBOOK_FILTER_PAYED_RETURNED_COMPOSED) ? formatText('accountCheques-filterNoResults') : formatText('accountCheques-noResults');
                content = <EmptyState primaryText={noResultsText} iconType="search-banking" />;
            }
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

AccountChequebookMovementsTable.propTypes = {
    accountId: PropTypes.string.isRequired,
    chequebookId: PropTypes.string.isRequired,
    immChequebook: PropTypes.object.isRequired,
    chequebookFilter: PropTypes.string.isRequired,
    requestNextAccountChequebookPage: PropTypes.func.isRequired
};

module.exports = connect(null, {
    requestNextAccountChequebookPage: accountChequeBookActions.requestNextAccountChequebookPage
})(AccountChequebookMovementsTable);
